import React from 'react';
import { Col, Row } from 'reactstrap';
import { Label } from 'edozvola-frontend-lib/dist/ui';
import { Input, PredictiveInput } from 'edozvola-frontend-lib/dist/ui/components';
import { useParams } from 'react-router-dom';
import { ChamberMemberCodebookModel } from 'app/shared/model/shared.model';
import {
  fetchChamberMembersQuery,
  fetchMainProjectTypeQueryForCaseCategory
} from 'app/edozvola/codebooks/codebooks.queries';
import {PaginatedDropdown} from "edozvola-frontend-lib/dist/ui/components/paginated-dropdown";

export interface ICaseMainProjectDataFormProps {
  readOnly: any;
  projectDataFormik: any;
}

const CaseMainProjectDataForm = ({readOnly, projectDataFormik}: ICaseMainProjectDataFormProps)  => {
  const { id: uuid } = useParams<{ id: string }>();

  const { data: chamberMemberOptions, isLoading: chamberMemberOptionsLoading } = fetchChamberMembersQuery();
  const { data: projectTypeOptions, isLoading: projectTypeOptionsLoading } = fetchMainProjectTypeQueryForCaseCategory(uuid);

  const onChamberMemberChanged = (selected: ChamberMemberCodebookModel[]) => {
    projectDataFormik.setValues({
      ...projectDataFormik.values,
      mainProjectAuthorizedDesigner: {
        authorizationNumber: selected,
        oib: selected[0] ? selected[0].oib : '',
      },
      mainProjectAuthorizationNumberExists: selected.length > 0
    });
  };

  return (
    <div className={'d-flex justify-content-between flex-column gap-3'}>
      <div className="form-header">Podaci o glavnom projektu</div>
      <Row>
        <Col md={6}>
          <Label labelText={'Vrsta projekta'} />
          <PaginatedDropdown
            placeholder={!readOnly && 'Odaberi vrstu projekta'}
            onItemSelect={selected => projectDataFormik.setFieldValue('mainProjectType', selected)}
            selected={projectDataFormik.values.mainProjectType}
            labelKey={'value'}
            options={projectTypeOptionsLoading ? [] : projectTypeOptions}
            disabled={readOnly}
            error={!readOnly && (projectDataFormik.errors.mainProjectType as string)}
            showErrorMessage
          />
        </Col>
        <Col md={6}>
          <Label labelText={'Zajednička oznaka projekta'} />
          <Input
            disabled={readOnly}
            value={projectDataFormik.values.projectMark}
            id="projectMark"
            name="projectMark"
            maxLength={100}
            onChange={projectDataFormik.handleChange}
            onBlur={projectDataFormik.handleBlur}
            error={!readOnly && projectDataFormik.errors.projectMark ? `${projectDataFormik.errors.projectMark}` : ''}
          />
        </Col>
      </Row>
      <hr />
      <div className={'form-header'}>Ovlašteni projektant</div>
      <Row>
        <Col md={6}>
          <Label labelText={'Broj ovlaštenja/Ime i prezime'} />
          <PaginatedDropdown
            placeholder={!readOnly && 'Odaberi broj ovlaštenja/ime i prezime'}
            onItemSelect={onChamberMemberChanged}
            selected={projectDataFormik.values.mainProjectAuthorizedDesigner.authorizationNumber}
            labelKey={'value'}
            options={chamberMemberOptionsLoading ? [] : chamberMemberOptions}
            disabled={readOnly}
            clearButton
            error={
              !readOnly &&
              projectDataFormik.errors.mainProjectAuthorizedDesigner &&
              projectDataFormik.errors.mainProjectAuthorizedDesigner['authorizationNumber']
                ? (projectDataFormik.errors.mainProjectAuthorizedDesigner['authorizationNumber'] as string)
                : ''
            }
            showErrorMessage
          />
        </Col>
        <Col md={6}>
          <Label labelText={'OIB'} />
          <Input disabled value={projectDataFormik.values.mainProjectAuthorizedDesigner.oib} />
        </Col>
      </Row>
    </div>
  );
}

export default CaseMainProjectDataForm;
